import React, { createContext, useContext, useState, useCallback } from 'react';

interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
  refreshLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState('cs');

  const setLanguage = useCallback((lang: string) => {
    setLanguageState(lang);
  }, []);

  const refreshLanguage = useCallback(() => {
    // Force re-render of components using translations
    setLanguageState(prev => prev);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, refreshLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
